import { VIEWS_KEY, _c } from '@app/constants';
import { DataSource } from '@n7-frontend/core';

export class FooterDS extends DataSource {
  protected transform(data) {
    const footer = _c(VIEWS_KEY).footer;
    
    return footer.enabled ? footer: undefined;
  }
}